import { ClientOptions, createRpcClient } from "@redotech/rpc/client";
import { InferRpcDefinition } from "@redotech/rpc/definition";
import { getProductQuestionsSchema } from "../schema/get-product-questions";
import { addProductsToCustomerProductListSchema } from "./add-products-to-customer-product-list-schema";
import { createOneTimePasscodeSchema } from "./create-one-time-passcode-schema";
import { createReviewDiscountSchema } from "./create-review-discount";
import { createReviewSchema } from "./create-review-schema";
import { getCustomerAuthFromCustomerWidgetAuthSchema } from "./get-customer-auth-from-customer-widget-auth-schema";
import { getShopifyExtensionTeamInfoSchema } from "./get-shopify-extension-team-info-schema";
import { getTreatmentsSchema } from "./get-treatments";
import { getActiveReviewFormSchema } from "./review-form/get-active-review-form-schema";
import { getProductReviewsRatingSchema } from "./reviews/get-product-reviews-rating-schema";
import { getReviewsSummaryByProductIdSchema } from "./reviews/get-reviews-summary-by-product-id";
import { getSignupFormSchema } from "./signup-form/get-signup-form-schema";
import { submitSignupFormStepSchema } from "./signup-form/submit-signup-form-step-schema";
import { logSignupFormAnalyticsSchema } from "./signup-form/view-signup-form-schema";
import { verifyOneTimePasscodeSchema } from "./verify-one-time-passcode-schema";

export const redoShopifyRPC = {
  addProductsToCustomerProductList: addProductsToCustomerProductListSchema,
  getCustomerAuthFromCustomerWidgetAuth:
    getCustomerAuthFromCustomerWidgetAuthSchema,
  getShopifyExtensionTeamInfo: getShopifyExtensionTeamInfoSchema,
  createOneTimePasscode: createOneTimePasscodeSchema,
  verifyOneTimePasscode: verifyOneTimePasscodeSchema,
  getReviewsSummaryByProductId: getReviewsSummaryByProductIdSchema,
  getSignupForm: getSignupFormSchema,
  logSignupFormAnalytics: logSignupFormAnalyticsSchema,
  submitSignupFormStep: submitSignupFormStepSchema,
  getTreatments: getTreatmentsSchema,
  getProductQuestions: getProductQuestionsSchema,
  createReviewDiscount: createReviewDiscountSchema,
  getProductReviewsRating: getProductReviewsRatingSchema,
  getActiveReviewForm: getActiveReviewFormSchema,
  createReview: createReviewSchema,
};

export type RedoShopifyRpcDefiniton = InferRpcDefinition<typeof redoShopifyRPC>;

export const createRedoShopifyRpcClient = (
  options: ClientOptions<typeof redoShopifyRPC>,
) => createRpcClient(redoShopifyRPC, options);

export type RedoShopifyRpcClient = ReturnType<
  typeof createRedoShopifyRpcClient
>;
